import { render, staticRenderFns } from "./EstadoDeudaShow.vue?vue&type=template&id=084f2dc3"
import script from "./EstadoDeudaShow.vue?vue&type=script&lang=js"
export * from "./EstadoDeudaShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports